<template>
    <div class="container">
        <StepGuide :stepCount="2"></StepGuide>
        <div class="padding body">
            <h1 class="teal textAlignCenter paddingTitle">Order Review</h1>
            <!--{{printJob.printJobSpec}}-->
            <div class="overflowCheckout">
                <div class="paddingBottom padding">
                    <div class="">
                        <div class="column48 leftContainer">
                            <div class="optionHeader column48">
                                <h3 class="teal textAlignCenter">Billing & Delivery Address</h3>
                            </div>
                            <table class="font10">
                                <tr class="lineHeight20">
                                    <td class="textAlignLeft label">Address</td>
                                    <td class="addressColumnData">{{customerDetails.address1}}</td>
                                </tr>
                                <tr class="lineHeight20">
                                    <td class="label"></td>
                                    <td class="addressColumnData">{{customerDetails.address2}}</td>
                                </tr>
                                <tr class="lineHeight20">
                                    <td class="label"></td>
                                    <td class="addressColumnData">{{customerDetails.address3}}</td>
                                </tr>
                                <tr class="lineHeight">
                                    <td class="textAlignLeft label">Town/City</td>
                                    <td class="addressColumnData">{{customerDetails.town}}</td>
                                </tr>
                                <tr class="lineHeight">
                                    <td class="textAlignLeft label">County</td>
                                    <td class="addressColumnData">{{customerDetails.county}}</td>
                                </tr>
                                <tr class="lineHeight">
                                    <td class="textAlignLeft label">Postcode</td>
                                    <td class="addressColumnData">{{customerDetails.postcode}}</td>
                                </tr>
                                <tr class="lineHeight36">
                                    <td class="textAlignLeft label">Invoice&nbsp;Email</td>
                                    <td class="addressColumnData">{{customerDetails.accountsEmail}}</td>
                                    <!--<td class="addressColumnData">SARAH.STEPHENSON@RAVENSWORTH.CO.UKdsfgsdfgdsfgsdfgsdfgdsfgsdfgsd</td>-->
                                </tr>
                            </table>
                        </div>
                        <div class="column4 leftContainer">
                            &nbsp;
                        </div>
                        <div class="column48 leftContainer greyBackground">
                            <div class="optionHeader"><h3 class="teal textAlignCenter">Order Details</h3></div>
                            <div class="font10 optionMargin paddingBottom">
                                <table class="container">
                                    <tr class="font10">
                                        <td class="column80 paddingNone textAlignLeft lightGreyFont">{{jobReference}}</td>
                                        <td class="paddingNone optionMargin"></td>
                                    </tr>
                                    <tr class="font10">
                                        <td class="column80 textAlignRight borderTop paddingRight lightGreyFont">Subtotal (ex.VAT):</td>
                                        <td class="borderTop optionMargin">£{{printJob.netTotalPrice}}</td>
                                    </tr>
                                    <tr class="font10">
                                        <td class="column80 textAlignRight borderTop paddingRight lightGreyFont">VAT:</td>
                                        <td class="borderTop optionMargin">
                                            £{{printJob.vatTotalPrice}}
                                        </td>
                                    </tr>
                                    <tr class="teal font12">
                                        <td class="column80 textAlignRight borderTop borderBottom paddingRight">
                                            Total:
                                        </td>
                                        <td class="borderTop borderBottom textAlignRight optionMargin">
                                            £{{printJob.grossTotalPrice}}
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="leftContainer column95 marginBody bold support">
                        <p class="textAlignCenter font12">
                            Please check the details above carefully<br>
                            If you need to make changes, please contact Ravensworth Client Support<br>
                        </p>
                        <div class="teal textAlignCenter">
                            0191 917 9331<br>
                            client.support@ravensworth.co.uk
                        </div>
                    </div>
                </div>


                <!--<div class="padding centerContainer">-->
                <!--<p class="textAlignCenter support">-->
                <!--Please check the details above carefully<br>-->
                <!--If you need to make changes, please contact Ravensworth Client Support<br>-->
                <!--<span class="teal">-->
                <!--0191 917 9331<br>-->
                <!--client.support@ravensworth.co.uk-->
                <!--</span>-->
                <!--</p>-->
                <!--</div>-->



                <div class="column70 centerContainer">
                    <div class="buttonPadding centerContainer">
                        <el-button class="redButton ravensworthButtons leftContainer" v-on:click="amendOrder()">
                            Amend Order
                        </el-button>
                        <el-button class="redButton ravensworthButtons rightContainer" v-on:click="next()">Confirm Order</el-button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>import Axios from 'axios';
    import Router from '../router';
    import StepGuide from '@/components/StepGuide.vue';
    import PrintJobSelections from '@/components/PrintJobSelections.vue';

    export default {
        name: "reivew",
        components: {
            StepGuide,
            PrintJobSelections
        },
        props: {
            searchParams: {},
            printJob: {}
        },
        data() {
            return {
                uploadPercentage: '',
                customerDetails: {},
                jobReference: ''
            }
        },
        created() {

            if (typeof this.printJob === 'undefined') {
                this.printJob = JSON.parse(window.sessionStorage.getItem('_printJob'))
                console.log(this.printJob)
            }

            this.jobReference = window.sessionStorage.getItem('_propertyName')
            console.log('getCustomer')
            const getCustomer = `${process.env.VUE_APP_BACKENDHOST}/api/v1/pdfUpload/Catalogue/FindCustomerByRef?customerRef=` + window.sessionStorage.getItem('_branchCode')
            console.log(getCustomer)
            Axios.get(getCustomer, {
                headers: {
                    "content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Authorization": "Bearer " + window.sessionStorage.getItem('_token')
                }
            })
                .then(response => {
                    this.customerDetails = response.data
                    console.log(this.customerDetails)
                })

            this.printJob.grossTotalPrice = this.printJob.grossTotalPrice.toFixed(2)
            this.printJob.netTotalPrice = this.printJob.netTotalPrice.toFixed(2)
            this.printJob.vatTotalPrice = this.printJob.vatTotalPrice.toFixed(2)
        },
        methods: {
            next() {
                Router.push({
                    name: 'checkout',
                    params: {
                        printJob: this.printJob
                    }
                });
            },
            amendOrder() {
                Router.push({
                    name: 'wizardProducts',
                    params: {
                        printJob: this.printJob
                    }
                });
            }
        }
    };</script>
